import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Switch } from '../ui/switch';
import { Phone, Bell, Save } from 'lucide-react';

const SmsNotificationsTab = ({
  onboardingStatus, setPhoneDialogOpen,
  notificationPrefs, setNotificationPrefs,
  savingNotifPrefs, saveNotificationPrefs
}) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Phone className="h-5 w-5 text-[#E8722A]" />
        SMS Notifications
      </CardTitle>
      <CardDescription>Manage your phone number and notification preferences for text alerts</CardDescription>
    </CardHeader>
    <CardContent className="space-y-6">
      <div className="p-4 bg-[#F5F5F5] rounded-lg border">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className={`w-3 h-3 rounded-full ${onboardingStatus?.sms_verified ? 'bg-green-500' : 'bg-red-400'}`} />
            <div>
              <p className="font-medium text-[#333333]">{onboardingStatus?.sms_verified ? 'Phone Verified' : 'Phone Not Configured'}</p>
              {onboardingStatus?.sms_phone && <p className="text-sm text-[#666666]">{onboardingStatus.sms_phone}</p>}
            </div>
          </div>
          <Button
            variant={onboardingStatus?.sms_verified ? "outline" : "default"}
            onClick={() => setPhoneDialogOpen(true)}
            className={onboardingStatus?.sms_verified ? "" : "bg-[#E8722A] hover:bg-[#D6621F]"}
          >
            {onboardingStatus?.sms_verified ? 'Change Number' : 'Add Phone Number'}
          </Button>
        </div>
      </div>

      <div className="space-y-4">
        <h3 className="font-semibold text-[#333333]">Notification Preferences</h3>
        <p className="text-sm text-[#666666]">Choose which events trigger SMS notifications:</p>
        <div className="space-y-3">
          {[
            { key: 'new_application', label: 'New candidate application received', desc: 'Get notified when someone applies' },
            { key: 'status_updated', label: 'Candidate status updated', desc: 'Pipeline stage changes' },
            { key: 'offer_signed', label: 'Offer letter signed', desc: 'When a candidate signs their offer' },
            { key: 'interview_reminder', label: 'Interview reminder (24 hours before)', desc: 'Upcoming interview alerts' },
          ].map(({ key, label, desc }) => (
            <div key={key} className="flex items-center justify-between p-3 bg-white rounded-lg border">
              <div className="flex items-center gap-3">
                <Bell className="h-5 w-5 text-[#E8722A]" />
                <div>
                  <p className="font-medium">{label}</p>
                  <p className="text-sm text-[#666666]">{desc}</p>
                </div>
              </div>
              <Switch
                checked={notificationPrefs[key]}
                onCheckedChange={(checked) => setNotificationPrefs(prev => ({ ...prev, [key]: checked }))}
              />
            </div>
          ))}
        </div>
        <Button onClick={saveNotificationPrefs} disabled={savingNotifPrefs} className="bg-[#E8722A] hover:bg-[#D6621F]">
          <Save className="mr-2 h-4 w-4" />
          {savingNotifPrefs ? 'Saving...' : 'Save Preferences'}
        </Button>
      </div>
    </CardContent>
  </Card>
);

export { SmsNotificationsTab };
